import { Communication } from '../redux/ducks'

const communicationThrewError = (
  { error: lastError }: Communication,
  { error }: Communication,
) => !lastError && error

export default communicationThrewError



// WEBPACK FOOTER //
// ./src/project-utils/communication-threw-error.tsx